import React from 'react'
import { Row, Col } from 'react-flexbox-grid'
import { useTranslation } from 'react-i18next'

import { useMutation, useQuery } from 'components/graphql'
import ContentBlock from 'components/ContentBlock'
import { Form, Text } from 'components/forms'
import Divider from 'components/Divider'

import getContentLanguageLabel from './getContentLanguageLabel'
import { queryLanguages, queryTranslations, mutateContentTranslations } from './gql'

const ContentTranslations = ({ id, translationTypes }) => {
	const languages = useQuery(queryLanguages)
	const translationLanguages = [...languages.data?.listContentTranslationLanguages?.items || []]
		.sort((a, b) => a.id > b.id)

	return(
		<ContentBlock isLoading={languages.loading}>
			{translationLanguages?.map((translationLanguage, i) => (
				<>
					<ContentTranslationLanguage key={i} recordId={id} translationLanguage={translationLanguage} translationTypes={translationTypes}/>
					<Divider visible/>
				</>
			))}
		</ContentBlock>
	)
}


const ContentTranslationLanguage = ({ recordId, translationLanguage, translationTypes }) => {
	const [, i18n] = useTranslation()
	const [setTranslations] = useMutation(mutateContentTranslations)
	const translations = useQuery(queryTranslations, {
		variables: {
			contentId: recordId,
			languageId: translationLanguage.id
		}
	})

	const fields = translationTypes.map(type => {
		const translation = translations.data?.listContentTranslations?.items?.find(item => item.contentType === type.type)
		return {
			...type,
			...translation
		}
	})

	const handleUpdate = ({ records }) => {
		const translationsToSet = fields.reduce((acc, field, i) => {
			const wasPresent = typeof fields[i] !== 'undefined'
			if(!wasPresent && !records[i]) {
				return acc
			}
			acc.push({
				id: field.id,
				fields: {
					contentId: recordId,
					contentType: field.type,
					languageId: translationLanguage.id,
					translation: records[i]?.translation || null
				}
			})
			return acc
		}, [])

		setTranslations({
			variables: {
				records: translationsToSet
			}
		})
	}

	return(
		<Form
			smartSubmit
			initialValues={{
				records: fields
			}}
			onSubmit={handleUpdate}
		>
			<h3>{getContentLanguageLabel(translationLanguage.locale, i18n.store.data?.[i18n.language]?.locale)}</h3>
			<Row>
				<Col xs>
					{fields.map(({ Component = Text, label }, i) => (
						<Component key={i} label={label} field={`records[${i}].translation`}/>
					))}
				</Col>
			</Row>
		</Form>
	)
}

export default ContentTranslations
